export const model = {
    id: '',
    bunk_id: '',
    resource: '', 
    start: '',
    end: '',   
    text: '',
    color: ''
};
